/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { gsap } from 'gsap';

const HeroBannerGSAP = ({ userData }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const shapes = gsap.utils.toArray('.shape');

      gsap.set(shapes, { opacity: 0, scale: 0, transformOrigin: 'center center' });
      gsap.to(shapes, {
        opacity: 1, scale: 1, duration: 0.65,
        stagger: 0.07, ease: 'back.out(1.5)', delay: 0.1
      });

      gsap.fromTo('.hero-title', { opacity: 0, y: 28 }, { opacity: 1, y: 0, duration: 0.75, delay: 0.65, ease: 'power3.out' });
      gsap.fromTo('.hero-sub', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.65, delay: 0.82, ease: 'power2.out' });

      shapes.forEach((el, i) => {
        const d = i % 2 === 0 ? 1 : -1;
        const dist = 8 + (i % 4) * 5;
        const rot = (i % 5 - 2) * 4;
        const dur = 2.6 + i * 0.32;
        gsap.to(el, {
          y: d * dist + 'px',
          rotation: rot,
          duration: dur,
          repeat: -1,
          yoyo: true,
          ease: 'sine.inOut',
          delay: i * 0.15
        });
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <Box ref={containerRef} w="full" maxW="100%" mx="auto" position="relative" minH="400px" bg="#f0f4ff" borderRadius="24px" overflow="hidden" display="flex" alignItems="center" justifyContent="center" py="60px" px="24px" fontFamily="'Google Sans', sans-serif">

      {/* BIG BLUE 4-PETAL FLOWER, top-left, pink sparkle inside */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', top: '-90px', left: '-140px', width: '420px' }} viewBox="0 0 200 200">
        <circle cx="100" cy="56" r="54" fill="#4285F4" />
        <circle cx="144" cy="100" r="54" fill="#4285F4" />
        <circle cx="100" cy="144" r="54" fill="#4285F4" />
        <circle cx="56" cy="100" r="54" fill="#4285F4" />
        <circle cx="100" cy="100" r="40" fill="#4285F4" />
        <path d="M100,58 C100,58 110,84 136,94 C110,104 100,130 100,130 C100,130 90,104 64,94 C90,84 100,58 100,58Z" fill="#F4A9A8" />
      </svg>



      {/* RED 4-PETAL FLOWER, top-center overlapping title */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', top: '-50px', left: '50%', marginLeft: '-125px', width: '250px' }} viewBox="0 0 200 200">
        <circle cx="100" cy="56" r="54" fill="#EA4335" />
        <circle cx="144" cy="100" r="54" fill="#EA4335" />
        <circle cx="100" cy="144" r="54" fill="#EA4335" />
        <circle cx="56" cy="100" r="54" fill="#EA4335" />
        <circle cx="100" cy="100" r="40" fill="#EA4335" />
      </svg>

      {/* PURPLE 4-PETAL FLOWER, top-right, big red sparkle inside */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', top: '-30px', right: '-50px', width: '280px' }} viewBox="0 0 200 200">
        <circle cx="100" cy="56" r="52" fill="#C58AF9" />
        <circle cx="144" cy="100" r="52" fill="#C58AF9" />
        <circle cx="100" cy="144" r="52" fill="#C58AF9" />
        <circle cx="56" cy="100" r="52" fill="#C58AF9" />
        <circle cx="100" cy="100" r="38" fill="#C58AF9" />
        <path d="M100,52 C100,52 112,82 140,94 C112,106 100,136 100,136 C100,136 88,106 60,94 C88,82 100,52 100,52Z" fill="#EA4335" />
      </svg>

      {/* BLUE 4-PETAL FLOWER, bottom-right, yellow sparkle inside */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', bottom: '10px', right: '-30px', width: '220px' }} viewBox="0 0 200 200">
        <circle cx="100" cy="56" r="54" fill="#4285F4" />
        <circle cx="144" cy="100" r="54" fill="#4285F4" />
        <circle cx="100" cy="144" r="54" fill="#4285F4" />
        <circle cx="56" cy="100" r="54" fill="#4285F4" />
        <circle cx="100" cy="100" r="40" fill="#4285F4" />
        <path d="M100,55 C100,55 112,82 140,94 C112,106 100,133 100,133 C100,133 88,106 60,94 C88,82 100,55 100,55Z" fill="#FBBC04" />
      </svg>

      {/* SMALL GREEN 4-PETAL FLOWER, bottom-left */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', bottom: '-20px', left: '15px', width: '180px' }} viewBox="0 0 200 200">
        <circle cx="100" cy="60" r="50" fill="#34A853" />
        <circle cx="140" cy="100" r="50" fill="#34A853" />
        <circle cx="100" cy="140" r="50" fill="#34A853" />
        <circle cx="60" cy="100" r="50" fill="#34A853" />
        <circle cx="100" cy="100" r="36" fill="#34A853" />
      </svg>

      {/* SMALL RED 4-PETAL FLOWER, bottom-left mid */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', bottom: '55px', left: '118px', width: '52px' }} viewBox="0 0 200 200">
        <circle cx="100" cy="60" r="50" fill="#EA4335" />
        <circle cx="140" cy="100" r="50" fill="#EA4335" />
        <circle cx="100" cy="140" r="50" fill="#EA4335" />
        <circle cx="60" cy="100" r="50" fill="#EA4335" />
        <circle cx="100" cy="100" r="36" fill="#EA4335" />
      </svg>

      {/* SMALL YELLOW 4-PETAL FLOWER, upper-right */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', top: '14px', right: '158px', width: '58px' }} viewBox="0 0 200 200">
        <circle cx="100" cy="60" r="48" fill="#FBBC04" />
        <circle cx="140" cy="100" r="48" fill="#FBBC04" />
        <circle cx="100" cy="140" r="48" fill="#FBBC04" />
        <circle cx="60" cy="100" r="48" fill="#FBBC04" />
        <circle cx="100" cy="100" r="34" fill="#FBBC04" />
      </svg>



      {/* BIG PINK SPARKLE, left-center */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', top: '50%', left: '120px', marginTop: '-55px', width: '100px' }} viewBox="0 0 100 100">
        <path d="M50,2 C50,2 60,40 98,50 C60,60 50,98 50,98 C50,98 40,60 2,50 C40,40 50,2 50,2Z" fill="#F4A9A8" />
      </svg>

      {/* BIG PURPLE SPARKLE, bottom-right area */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', bottom: '70px', right: '148px', width: '72px' }} viewBox="0 0 100 100">
        <path d="M50,2 C50,2 60,40 98,50 C60,60 50,98 50,98 C50,98 40,60 2,50 C40,40 50,2 50,2Z" fill="#C58AF9" />
      </svg>

      {/* YELLOW 9-PETAL FLOWER, bottom-center */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', bottom: '-45px', left: '50%', marginLeft: '-200px', width: '140px' }} viewBox="0 0 200 200">
        <circle cx="100" cy="54" r="44" fill="#FBBC04" />
        <circle cx="140" cy="67" r="44" fill="#FBBC04" />
        <circle cx="158" cy="107" r="44" fill="#FBBC04" />
        <circle cx="143" cy="148" r="44" fill="#FBBC04" />
        <circle cx="104" cy="163" r="44" fill="#FBBC04" />
        <circle cx="63" cy="150" r="44" fill="#FBBC04" />
        <circle cx="44" cy="110" r="44" fill="#FBBC04" />
        <circle cx="58" cy="68" r="44" fill="#FBBC04" />
        <circle cx="100" cy="100" r="44" fill="#FBBC04" />
      </svg>

      {/* LIGHT GREEN 4-PETAL FLOWER, bottom-left mid */}
      <svg className="shape" style={{ position: 'absolute', pointerEvents: 'none', willChange: 'transform', bottom: '70px', left: '60px', width: '82px' }} viewBox="0 0 200 200">
        <circle cx="100" cy="60" r="50" fill="#34A853" />
        <circle cx="140" cy="100" r="50" fill="#34A853" />
        <circle cx="100" cy="140" r="50" fill="#34A853" />
        <circle cx="60" cy="100" r="50" fill="#34A853" />
        <circle cx="100" cy="100" r="36" fill="#34A853" />
      </svg>

      <Box 
        position="relative" 
        zIndex={10} 
        textAlign="center" 
        maxW="800px"
      >
        <Text as="h1" className="hero-title" fontSize="clamp(36px, 5vw, 64px)" fontWeight="900" lineHeight="1.15" mb="24px" opacity={0} color="#1a1a2e">
          Build AI skills for tomorrow, today
        </Text>
        <Text as="p" className="hero-sub" fontSize="20px" fontWeight="600" lineHeight="1.65" mb="10px" opacity={0} color="#555555">
          Welcome back, {userData?.fullName ? userData.fullName.split(" ")[0] : "Student"}.<br />
          Future-proof your skills on our new learning platform built for you.
        </Text>
      </Box>
    </Box>
  );
};

export default HeroBannerGSAP;
